var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import { Paragraph } from "grommet";
import styled from "styled-components";
export var StyledParagraph = styled(Paragraph)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  color: white;\n  background-color: black;\n  border-radius: 30px;\n  padding: 2px 32px;\n",
    ]))
);
export var StyledHr = styled.hr(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  padding-bottom: 1px;\n  background-color: #b4bbc7;\n  width: 100%;\n  border-radius: 100px;\n",
    ]))
);
